// eslint-disable-next-line no-restricted-imports
import { OrganizationsResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';
import { client } from '@trello/graphql';
import {
  LoadTeamDocument,
  LoadTeamQuery,
  LoadTeamQueryVariables,
} from './LoadTeamQuery.generated';

export const LOAD_TEAM_REQUEST = Symbol('loaders/LOAD_TEAM_REQUEST');
export const LOAD_TEAM_SUCCESS = Symbol('loaders/LOAD_TEAM_SUCCESS');
export const LOAD_TEAM_ERROR = Symbol('loaders/LOAD_TEAM_ERROR');

export type LoadTeamRequestAction = Action<typeof LOAD_TEAM_REQUEST, string>;

export type LoadTeamSuccessAction = Action<
  typeof LOAD_TEAM_SUCCESS,
  OrganizationsResponse
>;

export type LoadTeamErrorAction = Action<typeof LOAD_TEAM_ERROR, Error>;

// Action creators
const loadTeamRequest = actionCreator<LoadTeamRequestAction>(LOAD_TEAM_REQUEST);
const loadTeamSuccess = actionCreator<LoadTeamSuccessAction>(LOAD_TEAM_SUCCESS);
const loadTeamError = actionCreator<LoadTeamErrorAction>(LOAD_TEAM_ERROR);

export const loadTeam = (teamName: string): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(loadTeamRequest(teamName));

      const { data, error } = await client.query<
        LoadTeamQuery,
        LoadTeamQueryVariables
      >({
        query: LoadTeamDocument,
        variables: {
          orgId: teamName,
        },
        context: {
          operationName: 'LoadTeam',
          document: LoadTeamDocument,
        },
      });

      if (error) {
        throw error;
      }

      const team: OrganizationsResponse = data.organization as OrganizationsResponse;

      dispatch(loadTeamSuccess(team));
    } catch (err) {
      dispatch(loadTeamError(err));
    }
  };
};
